/**
 * A production's pair grade (OK / WARN / EMERGENCY) and its reason, as the
 * overview decided them (`@acp/handlers/pairOverview.js`).
 */
import type { PairGrade, PairReason } from '@acp/api-contract/pairStatus.js';
import { GRADE_LABEL, GRADE_VARIANT, REASON_LABEL } from '../../lib/redundancy.js';
import { Badge } from '../ui/badge.js';

export type GradeBadgeProps = {
  readonly grade: PairGrade;
  readonly reason: PairReason;
};

export function GradeBadge({ grade, reason }: GradeBadgeProps) {
  return (
    <span className="inline-flex items-center gap-2" data-testid="pair-grade" data-grade={grade} data-reason={reason}>
      <Badge variant={GRADE_VARIANT[grade]}>{GRADE_LABEL[grade]}</Badge>
      <span className="text-sm">{REASON_LABEL[reason]}</span>
    </span>
  );
}
